import { render, staticRenderFns } from "./AutomationUserPermissionRow.vue?vue&type=template&id=625426d2&scoped=true"
import script from "./AutomationUserPermissionRow.vue?vue&type=script&lang=js"
export * from "./AutomationUserPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./AutomationUserPermissionRow.vue?vue&type=style&index=0&id=625426d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625426d2",
  null
  
)

export default component.exports